import globalStyles from '../../styles/exported.module.scss';

export const BackArrow = ({ className }: { className?: string }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M8 16L0 8L8 0L9.425 1.4L3.825 7H16V9H3.825L9.425 14.6L8 16Z" fill={globalStyles.bdPureWhite} />
  </svg>
);
